import {InnerTabs, MyBreadcrumb, MyText} from "../../../../components";
import React, {useEffect} from "react";
import {Card, Col, Row, Spin, Table} from "antd";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store";
import {selectStore} from "../../../../store/selector";
import dayjs from "dayjs";
import {getJournalTableInnerView} from "../../../../store/pages/journal/actions";

const QUERY_PARAMS = {
  end_date: 'end_date',
  start_date: 'start_date',
  ctp_id: 'ctp_id',
  type: 'type',
}

export const JournalInnerPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const {id} = useParams()
  const {t} = useTranslation("common")
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    journal: {tableInnerView: tableState},
  }: RootState = useSelector(selectStore)

  const start_date = searchParams.get(QUERY_PARAMS.start_date);
  const end_date = searchParams.get(QUERY_PARAMS.end_date);
  const ctp_id = searchParams.get(QUERY_PARAMS.ctp_id);
  const type = searchParams.get(QUERY_PARAMS.type);


  useEffect(() => {
    let body = {
      start_date,
      end_date,
      ctp_id,
    }

    let data = {
      type: type,
      body: body
    }

    dispatch(getJournalTableInnerView(data))
  }, []);

  const title = {
    '0': 'Название практик',
    '4': 'Консультация методиста',
    '3': 'Учет практики',
  }

  const columnsPracticeName = [
    {
      key: 'number',
      title: '№ п/п',
      dataIndex: 'number',
      width: 80,
      render: (text: any, record: any, index: any) => {
        return index + 1
      }
    },
    {
      key: 'date',
      title: 'Дата',
      dataIndex: 'date',
      width: 150,
      render: (text: any, record: any, index: any) => {
        return dayjs(text).format('DD.MM.YYYY');
      }
    },
    {
      key: 'fio',
      title: 'Фио обучающегося',
      dataIndex: 'fio',
      width: 200,
    },
    {
      key: 'mark',
      title: 'Оценка',
      dataIndex: 'mark',
      width: 200,
    },
    {
      key: 'teacher_name',
      title: 'ФИО учителя (воспитателя)',
      dataIndex: 'teacher_name',
      width: 200,
    },
    {
      key: 'school_class',
      title: 'Школа-класс (ДОУ-группа)',
      dataIndex: 'school_class',
      width: 200,
    },
    {
      key: 'hours',
      title: 'Часы методиста',
      dataIndex: 'hours',
      width: 150,
    },
    {
      key: 'hours_teacher',
      title: 'Часы учителя (воспитателя)',
      dataIndex: 'hours_teacher',
      width: 150,
    }
  ]

  const columnsConsultMethodist = [
    {
      key: 'number',
      title: '№ п/п',
      dataIndex: 'number',
      width: 80,
      render: (text: any, record: any, index: any) => {
        return index + 1
      }
    },
    {
      key: 'date',
      title: 'Дата',
      dataIndex: 'date',
      width: 150,
      render: (text: any, record: any, index: any) => {
        return dayjs(text).format('DD.MM.YYYY');
      }
    },
    {
      key: 'fio',
      title: 'Фио обучающегося',
      dataIndex: 'fio',
      width: 200,
    },
    {
      key: 'mark',
      title: 'Оценка',
      dataIndex: 'mark',
      width: 200,
    },
    {
      key: 'theme',
      title: 'Тема',
      dataIndex: 'theme',
      width: 200,
    },
    {
      key: 'school_class',
      title: 'Школа-класс (ДОУ-группа)',
      dataIndex: 'school_class',
      width: 200,
    },
    {
      key: 'hours',
      title: 'Кол-во часов',
      dataIndex: 'hours',
      width: 150,
    }
  ]

  const columnsPracticeAccount = [
    {
      key: 'number',
      title: '№ п/п',
      dataIndex: 'number',
      width: 80,
      render: (text: any, record: any, index: any) => {
        return index + 1
      }
    },
    {
      key: 'date_at',
      title: 'Дата',
      dataIndex: 'date_at',
      width: 150,
      render: (text: any, record: any, index: any) => {
        return dayjs(text).format('DD.MM.YYYY');
      }
    },
    {
      key: 'teacher_name',
      title: 'Фио учителя (Воспитателя)',
      dataIndex: 'teacher_name',
      width: 200,
    },
    {
      key: 'theme',
      title: 'Тема',
      dataIndex: 'theme',
      width: 200,
    },
    {
      key: 'school_class',
      title: 'Школа-класс (ДОУ-группа)',
      dataIndex: 'school_class',
      width: 200,
    },
    {
      key: 'hours',
      title: 'Кол-во часов',
      dataIndex: 'hours',
      width: 150,
    }
  ]

  const columns: any = {
    '0': columnsPracticeName,
    '4': columnsConsultMethodist,
    '3': columnsPracticeAccount,
  }

  return (
    <>
      <MyBreadcrumb title={t('back')} isBack/>
      <Row justify='center'>
        <Col span={20}>
          <Card>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <MyText size={24} weight={700}>
                  {/*// @ts-ignore*/}
                  {title[type]}
                </MyText>
              </Col>
              <Col span={24}>
                <Table
                  // @ts-ignore
                  columns={columns[type]}
                  dataSource={tableState?.data?.data || []}
                  pagination={false}
                  loading={tableState.loading}
                  rowKey={(record) => record.lesson_id}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}
